var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52585 20.9078H21.4741C21.8473 20.9078 22.15 20.605 22.15 20.2319C22.15 19.8588 21.8473 19.5561 21.4741 19.5561H3.52585C3.15274 19.5561 2.85 19.8588 2.85 20.2319C2.85 20.605 3.15274 20.9078 3.52585 20.9078ZM3.52585 13.0537H21.4741C21.8473 13.0537 22.15 12.7509 22.15 12.3778C22.15 12.0047 21.8473 11.702 21.4741 11.702H3.52585C3.15274 11.702 2.85 12.0047 2.85 12.3778C2.85 12.7509 3.15274 13.0537 3.52585 13.0537ZM3.52585 5.2017H21.4741C21.8473 5.2017 22.15 4.89896 22.15 4.52585C22.15 4.15274 21.8473 3.85 21.4741 3.85H3.52585C3.15274 3.85 2.85 4.15274 2.85 4.52585C2.85 4.89896 3.15274 5.2017 3.52585 5.2017Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawer);
export default __webpack_public_path__ + "static/media/icon_drawer_.bcda97c4b2d1cae31f305f17531fadb9.svg";
export { ForwardRef as ReactComponent };